import { promise } from '../../../helpers';

const validateOnSaveExam = () => {
    // eslint-disable-next-line
    return (dispatch, getState, getFirebase) => {
        return promise({ success: true });
    };
};

export default validateOnSaveExam;
